export const ASSIGNEE_SEARCH_QUERY_NAME = 'updateGroupIssueAssigneeSearch';
export const UPDATE_FIELD_QUERY_NAME = 'updateGroupIssueUpdateField';
